import { render } from "./Adress.vue?vue&type=template&id=0a555ece&scoped=true"
import script from "./Adress.vue?vue&type=script&lang=js"
export * from "./Adress.vue?vue&type=script&lang=js"

import "./Adress.vue?vue&type=style&index=0&id=0a555ece&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a555ece"]])

export default __exports__